export let config = {
	panel: [
		{
			id: 1,
			type: "solution",
			title: { en: "Fuel Injection System", de: "Fuel Injection System" },
			info: null,
			image: "",
			categories: [],
			engines: [1, 2, 3],
			description: "",
			links: [],
			children: [
				{
					id: 100,
					type: "solution",
					title: {
						en: "Electronic Fuel Injection (EFI)",
						de: "Electronic Fuel Injection (EFI)",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/electronic-fuel-injection-480x270px.jpg",
					categories: [3, 1, 5],
					engines: [1],
					description:
						"The Electronic Fuel Injection system uses sensors and electronic control unit to precisely control the timing and the quantity of the fuel injection into every cylinder of the engine, based on various inputs such as engine speed, load, and temper.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: { en: "Download brochure", de: "Download brochure" },
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_efi_EN_preview.pdf",
							mode: "",
							type: "external",
						},
						{
							text: { en: "More about EFI", de: "More about EFI" },
							url: "https://www.everllence.com/services/offerings/marine-power/pielstick-retrofit",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 101,
					type: "solution",
					title: { en: "Common Rail (CR)", de: "Common Rail (CR)" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/common-rail-retrofit-480x270px.jpg",
					categories: [3, 1, 5],
					engines: [2, 3],
					description:
						"Common Rail is an advanced fuel injection technology found within diesel engines. It functions by continuously pressurizing fuel in a small reservoir known as the common rail, from which it distributes precise amounts of fuel into each individual injector.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: { en: "Download brochure", de: "Download brochure" },
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_commonrail_EN_preview.pdf",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about Common Rail",
								de: "More about Common Rail",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/pielstick-retrofit",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 2,
			type: "solution",
			title: { en: "Liner", de: "Liner" },
			info: null,
			image: "",
			categories: [],
			engines: [1, 2, 3],
			description: "",
			links: [],
			children: [
				{
					id: 102,
					type: "solution",
					title: {
						en: "Anti-bore polishing ring",
						de: "Anti-bore polishing ring",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/anti-bore-polishing-ring-480x270px.jpg",
					categories: [3, 1],
					engines: [1, 2, 3],
					description:
						"The use of such a ring prevents the contact between the carbon deposits on the piston crown and the liner. These deposits often cause liner polishing which results in gas blow-by, risk of scuffing and increase lube oil consumption.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: { en: "Download brochure", de: "Download brochure" },
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_kit_anti-bore-polishing-ring_EN_preview.pdf",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 3,
			type: "solution",
			title: {
				en: "Automation & condition monitoring",
				de: "Automation & condition monitoring",
			},
			info: null,
			image: "",
			categories: [],
			engines: [1, 2, 3],
			description: "",
			links: [],
			children: [
				{
					id: 103,
					type: "solution",
					title: { en: "SaCoS retrofit", de: "SaCoS retrofit" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/SaCoS-480x270px.jpg",
					categories: [3, 2],
					engines: [1, 2, 3],
					description:
						"SaCoS means Safety Control System. SaCoS has been developed to propose a turn-key control system Solution to equip new engines and for automation retrofits. In this way, the new technologies employed give their best on our robustness S.E.M.T. Pielstick engines.<br><br>Upgrade your Pielstick engines with SaCoS and unlock a new level of efficiency, performance and experience the future of engine management.<br><br>It’s fully CE compliant and approved by classification societies.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: { en: "Download brochure", de: "Download brochure" },
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_sacos_retrofit_EN_preview.pdf",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about SaCoS retrofit",
								de: "More about SaCoS retrofit",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/pielstick-retrofit",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 104,
					type: "solution",
					title: {
						en: "Engine controller 2.0",
						de: "Engine controller 2.0",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/engine-controller-480x270px.png",
					categories: [3, 2],
					engines: [1, 3],
					description:
						"The Pielstick engine controller 2.0 is the state-of-the-art engine speed regulation: the hardware and software have been specifically re-designed and re-developed from scratch, on the basics of newest technologies, to meet the most difficult operating conditions while extending the engine life cycle and preventing any obsolescence issues.<br><br>Qualification tests granted for temperature, vibration, choc, CEM, seismic, aging.<br><br>The engine controller 2.0 is nuclear certified and cybersecurity certified.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: { en: "Download brochure", de: "Download brochure" },
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/EVR-PS_Engine_Controller_EN_2507_Final_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 105,
					type: "solution",
					title: {
						en: "Electronic Speed Governor retrofit",
						de: "Electronic Speed Governor retrofit",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/electronic-speed-governor-ESG-480x270px.jpg",
					categories: [3, 2],
					engines: [1, 2, 3],
					description:
						"It’s the Everllence’s retrofit Solution for the engine speed controlling. This high efficient speed governor is based on a 32-bit microprocessor. The maintainability and spare parts supplying are secured.<br><ul><li>Unitary and operation engine tests</li><li>CE compliance and approval societies of classification</li></ul>",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: { en: "Download brochure", de: "Download brochure" },
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_esg_EN_preview.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 106,
					type: "solution",
					title: { en: "MMS for safety", de: "MMS for safety" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/electronic-speed-governor-ESG-480x270px.jpg",
					categories: [3, 2, 6],
					engines: [1, 2, 3],
					description:
						"As a complement to Multifunction Monitoring System, MMS for safety provides three optional specific modules that ensure the management of main engine safeties while the engine operation: crank pins lube oil temperature monitoring for crankshaft protection; main bearing monitoring for bearing protection and pressure monitoring for crankcase protection.<br><br>Sensors detect over deviation and active alarm or immediate stop order. That’s an additional range of modules to Multifunction Monitoring System. Modules are activated according to the operator’s needs.<br><br>The material is safety qualified for engine stops for marine applications: CE, BV, DNV, DNV-GL, GL, RS, LR, RINA, ABS, RMRS, CCS, KR, NK.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: { en: "Download brochure", de: "Download brochure" },
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_mms-for-safety_EN_preview.pdf",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about MMS for safety",
								de: "More about MMS for safety",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/multifunction-monitoring-systems",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 107,
					type: "solution",
					title: {
						en: "Multifunction Monitoring System (MMS)",
						de: "Multifunction Monitoring System (MMS)",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/electronic-speed-governor-ESG-480x270px.jpg",
					categories: [3, 2],
					engines: [1, 2, 3],
					description:
						"Multifunction Monitoring System provides in a unique panel, the monitoring management system of the crucial operating data of the running engine and its auxiliaries.<br><br>Thanks to six complementary sources of data, MMS monitors the health and the behavior of the engine and its auxiliaries that are experiencing high strain and are central for global engine efficiency.<br><ul><li>Compliance: CE, Bureau Veritas, DNV, GL, KR, CCS, ABS, RINA</li></ul>",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: { en: "Download brochure", de: "Download brochure" },
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_mms_EN_preview.pdf",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about Multifunction Monitoring System",
								de: "More about Multifunction Monitoring System",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/multifunction-monitoring-systems",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 108,
					type: "solution",
					title: {
						en: "MFM for lube oil (Multi Fluid Monitor)",
						de: "MFM for lube oil (Multi Fluid Monitor)",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/multi-fluid-monitor-480x270px.jpg",
					categories: [3, 2],
					engines: [1, 2, 3],
					description:
						"Everllence Multi Fluid Monitor for lube oil constantly monitors the lube oil. Using truly autonomous intelligence, it analyses the lube oil, detects anomalies and alerts the operator of any deviations. It provides a global view of all the operational lube oil parameters.<br><br>The solution is integrated into the main lube oil system of the equipment.<br><br>All types of four-stroke engines and two-stroke engines (system oil only) – Everllence and other brands, engine auxiliaries.<br><br>Everllence Multi Fluid Monitor for lube oil meets CE standards, has the following certifications:<ul><li>Marine: BV, ABS</li><li>Navy: NNO6630145997886, IEC shocks standards</li><li>Cyber Security: BV IACS UR E27</li></ul>",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about Multi Fluid Monitor",
								de: "More about Multi Fluid Monitor",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/multi-fluid-monitor",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about the importance of the lube oil into engine operation",
								de: "More about the importance of the lube oil into engine operation",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/multi-fluid-monitor/lube-oil-performance",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 109,
					type: "solution",
					title: {
						en: "Cylinder Pressure Monitoring (CyPreMo)",
						de: "Cylinder Pressure Monitoring (CyPreMo)",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/cypremo-480x270px.jpg",
					categories: [3],
					engines: [1, 2, 3],
					description:
						"CyPreMo, our field product performance monitoring system, is a constant cylinder pressure monitor on the engine. It elevates engine wear analysis and fuel quality evaluation, boosting efficiency, reliability, and cost savings, thus protecting engine performance and improving longevity.<br><ul><li>Marine type approval from all significant international classification societies such as Bureau Veritas, DNV, ABS, Lloyd's Register, Class NK and RINA.</li></ul>",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: { en: "Download brochure", de: "Download brochure" },
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/EVR_Pielstick_CyPreMo_Leaflet_EN_FINAL_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 4,
			type: "solution",
			title: { en: "Alternative fuels", de: "Alternative fuels" },
			info: null,
			image: "",
			categories: [],
			engines: [1, 2, 3],
			description: "",
			links: [],
			children: [
				{
					id: 110,
					type: "solution",
					title: {
						en: "Low sulphur fuel upgrade",
						de: "Low sulphur fuel upgrade",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/VLSFO-480x270px.jpg",
					categories: [5],
					engines: [1, 2, 3],
					description:
						"This engine type is directly compatible with the selected fuel. Operating low sulfur fuel significantly reduces fuel-induced contamination, optimizing operations in regulated zones. Revert to your operating manual and service letters.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about alternatives fuels",
								de: "More about alternatives fuels",
							},
							url: "https://www.man-es.com/services/strategic-expertise/alternative-fuels",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "Download service letters",
								de: "Download service letters",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-letters",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 111,
					type: "solution",
					title: { en: "Biofuel upgrade", de: "Biofuel upgrade" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/biofuel-upgrade-480x270px.jpg",
					categories: [5],
					engines: [1, 2, 3],
					description:
						"This engine type is directly compatible with the selected fuel. Revert to your operating manual and service letters.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about alternatives fuels",
								de: "More about alternatives fuels",
							},
							url: "https://www.man-es.com/services/strategic-expertise/alternative-fuels",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "Download service letters",
								de: "Download service letters",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-letters",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 5,
			type: "solution",
			title: { en: "Turbocharger", de: "Turbocharger" },
			info: null,
			image: "",
			categories: [],
			engines: [1, 2, 3],
			description: "",
			links: [],
			children: [
				{
					id: 112,
					type: "solution",
					title: { en: "Turbocharger retrofit", de: "Turbocharger retrofit" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/turbocharger-retrofit-480x270px.jpg",
					categories: [1, 2, 3, 4],
					engines: [1, 2, 3],
					description:
						"Retrofitting an existing engine with the latest Everllence turbocharger technology is an effective method of extending its useful life while also improving its performance, economics and environmental impact. Retrofit your turbocharger and gain up to 12 % of the turbocharger efficiency and expect return on investment in 2 years!",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: { en: "Download brochure", de: "Download brochure" },
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_turbocharger_retrofit_EN_preview.pdf",
							mode: "",
							type: "external",
						},
						{
							text: { en: "Watch video", de: "Watch video" },
							url: "https://www.youtube.com/watch?v=mwEBfcVcvv0",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 6,
			type: "service",
			title: { en: "Original spare parts", de: "Original spare parts" },
			info: null,
			image:
				"/apps/configurators/pielstick-engines-pa-pc/assets/images/original-spare-parts-480x270px.jpg",
			categories: [2, 3, 1, 4],
			engines: [1, 2, 3],
			description:
				"Ensure peak performance for your Pielstick engines with original spare parts by Everllence. All of our spare parts are manufactured according to genuine patents, plans, and nomenclatures. We meet high-quality requirements:<ul><li>Quality control parts</li><li>Documentary follow-up</li><li>Systematic supply of quality records</li><li>Traceability</li><li>Supplier accreditation</li></ul>These spare parts protect your investment while enhancing efficiency. Opt for safety and precision with original parts. For tailored assistance, reach out to our Service experts.",
			links: [
				{
					text: { en: "Contact our experts", de: "Contact our experts" },
					url: "#contact",
					mode: "fill",
					type: "",
				},
				{
					text: {
						en: "More about Pielstick spare parts",
						de: "More about Pielstick spare parts",
					},
					url: "https://www.everllence.com/services/offerings/marine-power/pielstick",
					mode: "",
					type: "external",
				},
			],
			children: [],
		},
		{
			id: 7,
			type: "service",
			title: { en: "Technical services", de: "Technical services" },
			info: null,
			image: "",
			categories: [],
			engines: [1, 2, 3],
			description: "",
			links: [],
			children: [
				{
					id: 113,
					type: "service",
					title: { en: "Reconditioning", de: "Reconditioning" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/reconditionning-480x270px.jpg",
					categories: [4, 2],
					engines: [1, 2, 3],
					description:
						"The Pielstick reconditioning is executed from Saint-Nazaire or Marseille on:<ul><li>Parts</li><li>Power packs</li><li>Cylinder heads and water jackets</li><li>Complete engine</li></ul>A wide range of in-house reconditioning services:<ul><li>Disassembly</li><li>Cleaning</li><li>Expertise, non-destructive test</li><li>Remachining</li><li>Reassembly</li></ul>",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
					],
				},
				{
					id: 114,
					type: "service",
					title: { en: "Trouble shooting", de: "Trouble shooting" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/trouble-shooting-480x270px.jpg",
					categories: [1, 2, 3],
					engines: [1, 2, 3],
					description:
						"Our PrimeServ service engineers come on site to troubleshoot engine and auxiliaries issues, starting with a visual inspection and using diagnostic tools. They analyze logs, evaluate performance metrics, test components, and check systems to identify and resolve faults.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about technical service for marine & power applications",
								de: "More about technical service for marine & power applications",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/technical-service",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about technical service for Pielstick engines",
								de: "More about technical service for Pielstick engines",
							},
							url: "https://www.everllence.com/services/service-locations/france",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 115,
					type: "service",
					title: { en: "Repairs", de: "Repairs" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/repairs-480x270px.jpg",
					categories: [1, 2, 3],
					engines: [1, 2, 3],
					description:
						"Our PrimeServ service engineers come on site to repair S.E.M.T. Pielstick engines and their auxiliaries. They perform visual inspections, repair or replace faulty components, update software if needed, and conduct thorough testing to ensure the engine operates smoothly.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about technical service for marine & power applications",
								de: "More about technical service for marine & power applications",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/technical-service",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about technical service for Pielstick engines",
								de: "More about technical service for Pielstick engines",
							},
							url: "https://www.everllence.com/services/service-locations/france",
							mode: "",
							type: "external",
						},
						{
							text: { en: "Download brochure", de: "Download brochure" },
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_crankcase_repair_EN_preview.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 116,
					type: "service",
					title: { en: "Technical assistance", de: "Technical assistance" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/lump-sum-turnKey-maintenance-execution-480x270px.jpg",
					categories: [1, 2, 3],
					engines: [1, 2, 3],
					description:
						"Supervision of service engineers in order to provide a technical assistance to the maintenance activities.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about technical service for marine & power applications",
								de: "More about technical service for marine & power applications",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/technical-service",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about technical service for Pielstick engines",
								de: "More about technical service for Pielstick engines",
							},
							url: "https://www.everllence.com/services/service-locations/france",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 117,
					type: "service",
					title: {
						en: "Execution of the complete maintenance programs",
						de: "Execution of the complete maintenance programs",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/lump-sum-turnKey-maintenance-execution-480x270px.jpg",
					categories: [1, 2, 3],
					engines: [1, 2, 3],
					description:
						"Technical assistance for one-shot global overhauling for 3000, 6000, 12000 and 24000 hours overhauls.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about technical service for marine & power applications",
								de: "More about technical service for marine & power applications",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/technical-service",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about technical service for Pielstick engines",
								de: "More about technical service for Pielstick engines",
							},
							url: "https://www.everllence.com/services/service-locations/france",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 132,
					type: "service",
					title: {
						en: "Service letters",
						de: "Service letters",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/semt-pielstick-engine-serviceletters.jpg",
					categories: [1, 2, 3],
					engines: [1, 2, 3],
					description:
						"Stay fully informed with the latest Pielstick Service Letters—traditionally known as Service Bulletins. This dedicated space gives you quick, reliable access to all technical updates that keep your Pielstick engines performing at their best. It ensures you always have the most recent recommendations, safety notes, and maintenance guidance from our experts.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: { en: "See service letters", de: "See service letters" },
							url: "https://www.everllence.com/services/offerings/marine-power/service-letters",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 8,
			type: "service",
			title: { en: "Maintenance", de: "Maintenance" },
			info: null,
			image: "",
			categories: [],
			engines: [1, 2, 3],
			description: "",
			links: [],
			children: [
				{
					id: 118,
					type: "service",
					title: { en: "Pielstick overhaul kit", de: "Pielstick overhaul kit" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/pielstick-overhaul-kits-480x270px.jpg",
					categories: [1, 2, 3],
					engines: [1, 2, 3],
					description:
						"Each kit contains all the necessary genuine S.E.M.T. Pielstick replacement, wearable parts and components that the maintenance manual requires for the 3000, 6000, 12000 and 24000 hours overhauls.<br><br>The exact genuine and high-quality spare parts provided in the kit allow your maintenance team to perform a scheduled overhaul in the best conditions.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: { en: "Download brochure", de: "Download brochure" },
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_pielstick_overhaul_kit_EN_preview.pdf",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about Pielstick overhaul kit",
								de: "More about Pielstick overhaul kit",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/pielstick",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 119,
					type: "service",
					title: {
						en: "Pielstick maintenance kits",
						de: "Pielstick maintenance kits",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/pielstick-maintenance-kits-480x270px.jpg",
					categories: [1, 2, 3],
					engines: [1, 2, 3],
					description:
						"Piston ring kits, injection kits and cylinder head kit contain all the necessary genuine S.E.M.T. Pielstick replacement parts along with an installation guide. This helps you limit any risks of unscheduled downtime and lost revenue, with minimum hassle and cost. Using such a kit extends the time between overhaul (TBO) and enables you to keep operating with even greater reliability and lower operating costs.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about Pielstick maintenance kits",
								de: "More about Pielstick maintenance kits",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/pielstick",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "Download brochure for Cylinder head overhaul kit",
								de: "Download brochure for Cylinder head overhaul kit",
							},
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_cylinder-head-overhaul-kit_EN_preview.pdf",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "Download brochure for Nozzle overhaul kit",
								de: "Download brochure for Nozzle overhaul kit",
							},
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_nozzle-overhaul-kit_EN_preview.pdf",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "Download brochure for Piston ring kit",
								de: "Download brochure for Piston ring kit",
							},
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_piston-ring-kit_EN_preview.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 120,
					type: "service",
					title: { en: "Strategic parts lists", de: "Strategic parts lists" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/strategicparts-lists-480x270px.jpg",
					categories: [1, 2, 3],
					engines: [1, 2, 3],
					description:
						"They contain components to change in case of damage, they are parts with very long delivery times. All S.E.M.T. Pielstick engine types and applications.<br><br>Spare parts:<ul><li>Counterweight</li><li>Complete cylinder head</li><li>Camshaft</li><li>Crankshaft</li><li>Crankcase</li><li>Camshaft damper</li><li>Crankshaft damper</li><li>Timing gearwheel</li><li>Turbocharger</li></ul>",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about strategic parts lists",
								de: "More about strategic parts lists",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/pielstick",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 121,
					type: "service",
					title: {
						en: "Conditional parts lists",
						de: "Conditional parts lists",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/strategicparts-lists-480x270px.jpg",
					categories: [1, 2, 3],
					engines: [1, 2, 3],
					description:
						"Those lists contain components that are not preventive maintenance, but that may need to be replaced following an inspection. All S.E.M.T. Pielstick engine types and applications.<br><br>Spare parts:<ul><li>Piston</li><li>Liner</li><li>Barrel</li><li>Connecting rod</li><li>Cylinder head components</li><li>Water jacket</li><li>Bearing shells</li><li>Injection pump expansion joint</li><li>Oil pump</li><li>Injector</li></ul>",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about conditional parts lists",
								de: "More about conditional parts lists",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/pielstick",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 9,
			type: "service",
			title: { en: "Nuclear services", de: "Nuclear services" },
			info: null,
			image: "",
			categories: [],
			engines: [1, 2, 3],
			description: "",
			links: [],
			children: [
				{
					id: 122,
					type: "service",
					title: {
						en: "Nuclear GenSet services",
						de: "Nuclear GenSet services",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/nuclear-genset-services-480x270px.jpg",
					categories: [3, 2],
					engines: [1, 2, 3],
					description:
						"Everllence, as the leader of the emergency GenSets market for nuclear plants, provides a wide range of services during the entire life cycle of the EDG. From general consultancy activities to on-site full maintenance, PrimeServ is the world-class service provider for all needs of support: from the maintenance strategy to the life extension plan, upgrades or reconditioning.<br><ul><li>Nuclear quality standards & qualifications: HN1, HN2, QSP, Secure, etc.</li><li>ISO 19443 - MAN Energy Solution France is LRQA certified for quality and nuclear safety</li></ul>",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: { en: "Download brochure", de: "Download brochure" },
							url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-ps_nuclear_genset_services_EN_preview.pdf",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 10,
			type: "service",
			title: { en: "Service agreements", de: "Service agreements" },
			info: null,
			image: "",
			categories: [],
			engines: [1, 2, 3],
			description: "",
			links: [],
			children: [
				{
					id: 123,
					type: "service",
					title: {
						en: "LTSA – Standard Maintenance Agreement (SMA)",
						de: "LTSA – Standard Maintenance Agreement (SMA)",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/LTS-480x270px.jpg",
					categories: [1, 2, 3, 5],
					engines: [1, 2, 3],
					description:
						"Long-term service agreements by PrimeServ are peace-of-mind solutions. The Standard Maintenance Agreement for Pielstick engines minimizes downtime and operational costs through proactive maintenance. We tailor service agreements to help you optimize the operational cost and budget reliability of preventive and conditioned-based maintenance. Get access to our Service experts at all times.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about LTSA for S.E.M.T. Pielstick engines",
								de: "More about LTSA for S.E.M.T. Pielstick engines",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-agreements#pielstick",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 124,
					type: "service",
					title: {
						en: "LTSA – Spare Parts Agreement (SPA)",
						de: "LTSA – Spare Parts Agreement (SPA)",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/LTS-480x270px.jpg",
					categories: [1, 2, 3, 5],
					engines: [1, 2, 3],
					description:
						"Long-term service agreements by PrimeServ are peace-of-mind solutions. LTSA – Spare Parts Agreement for Pielstick engines ensures timely spare part deliveries for scheduled maintenance. This first level of LTSA provides preferred pricing, reduced admin effort, and PrimeServ's on-time delivery commitment, enhancing operational efficiency and reliability.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about LTSA for S.E.M.T. Pielstick engines",
								de: "More about LTSA for S.E.M.T. Pielstick engines",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-agreements#pielstick",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 125,
					type: "service",
					title: {
						en: "LTSA – Condition Assessment (CA)",
						de: "LTSA – Condition Assessment (CA)",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/LTS-480x270px.jpg",
					categories: [1, 2, 3, 5],
					engines: [1, 2, 3],
					description:
						"Long-term service agreements by PrimeServ are peace-of-mind solutions. Optimize maintenance with LTSA – Condition Assessment Options for Pielstick engines, featuring diagnostic tools and remote monitoring by PrimeServ specialist. This approach ensures early detection for proactive maintenance and quick troubleshooting, minimizing downtime.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about LTSA for S.E.M.T. Pielstick engines",
								de: "More about LTSA for S.E.M.T. Pielstick engines",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-agreements#pielstick",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 126,
					type: "service",
					title: {
						en: "LTSA – Uptime Optimization (UO)",
						de: "LTSA – Uptime Optimization (UO)",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/LTS-480x270px.jpg",
					categories: [1, 2, 3, 5],
					engines: [1, 2, 3],
					description:
						"Long-term service agreements by PrimeServ are peace-of-mind solutions. LTSA – Uptime Optimization (UO) Options for Pielstick engines enhance uptime, offering rapid maintenance and fast response to unplanned events. Benefits include reduced downtime, strategic spare part pricing, PrimeServ maintenance crews, and guaranteed response times in case of emergencies.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about LTSA for S.E.M.T. Pielstick engines",
								de: "More about LTSA for S.E.M.T. Pielstick engines",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-agreements#pielstick",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 11,
			type: "service",
			title: { en: "Consultancy", de: "Consultancy" },
			info: null,
			image: "",
			categories: [],
			engines: [1, 2, 3],
			description: "",
			links: [],
			children: [
				{
					id: 127,
					type: "service",
					title: {
						en: "Obsolescence Management",
						de: "Obsolescence Management",
					},
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/obsolescence-management-480x270px.jpg",
					categories: [2, 3],
					engines: [1, 2, 3],
					description:
						"From identification of obsolescence risks to the implementation of concrete actions to mitigate them, we support our clients in maintaining their installation functional and competitive at long notice.<br><br>Our proactive strategy is based on an organization dedicated to obsolescence management, considered a full-fledged activity, with rigorous lifecycle management.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "More about Obsolescence Management",
								de: "More about Obsolescence Management",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/pielstick-retrofit",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 128,
					type: "service",
					title: { en: "Life extension plan", de: "Life extension plan" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/obsolescence-management-480x270px.jpg",
					categories: [3, 2],
					engines: [1, 2, 3],
					description:
						"Consultancy life cycle management services with PrimeServ specialists to meet each customer’s assistance needs:<ul><li>Supervision</li><li>Technical assistance</li><li>Maintenance</li><li>Retrofit & upgrade</li><li>Availability of spare parts</li></ul>We are able to recommend solutions, including addressing obsolescence issues, ensuring your systems remain up-to-date and efficient.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
					],
				},
				{
					id: 129,
					type: "service",
					title: { en: "Audit", de: "Audit" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/audit-480x270px.jpg",
					categories: [1, 2, 3, 4, 5],
					engines: [1, 2, 3],
					description:
						"Studies & simulations related to the reliability and the safety of the engines operating conditions are executed in order to comply with the most recent regulations.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
					],
				},
			],
		},
		{
			id: 12,
			type: "service",
			title: { en: "Turbocharger", de: "Turbocharger" },
			info: null,
			image: "",
			categories: [],
			engines: [1, 2, 3],
			description: "",
			links: [],
			children: [
				{
					id: 130,
					type: "service",
					title: { en: "Turbocharger service", de: "Turbocharger service" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/turbocharger-retrofit-480x270px.jpg",
					categories: [1, 2, 3, 4],
					engines: [1, 2, 3],
					description:
						"Everllence PrimeServ provides comprehensive overhauling services for all turbocharger equipments, as for TCs, Accelleron TC's, etc.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
					],
				},
			],
		},
		{
			id: 13,
			type: "service",
			title: { en: "PrimeServ Lab", de: "PrimeServ Lab" },
			info: null,
			image:
				"/apps/configurators/pielstick-engines-pa-pc/assets/images/primeServ-lab-480x270px.jpg",
			categories: [1, 2, 4, 5],
			engines: [1, 2, 3],
			description:
				"Analyze all your engine fluids to optimize operation and prevent damage with our PrimeServ Lab. It quickly delivers expert analysis and actionable insights. This solution is part of proactive maintenance and enhances engine performance and reliability, and thus reduces costs.",
			links: [
				{
					text: { en: "Contact our experts", de: "Contact our experts" },
					url: "#contact",
					mode: "fill",
					type: "",
				},
				{
					text: { en: "Download brochure", de: "Download brochure" },
					url: "/apps/configurators/pielstick-engines-pa-pc/assets/pdfs/evr-primeserv_lab-liquids_preview.pdf",
					mode: "",
					type: "external",
				},
				{
					text: {
						en: "More about the importance of the lube oil into engine operation",
						de: "More about the importance of the lube oil into engine operation",
					},
					url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/multi-fluid-monitor/lube-oil-performance",
					mode: "",
					type: "external",
				},
			],
			children: [],
		},
		{
			id: 14,
			type: "service",
			title: { en: "PrimeServ Academy", de: "PrimeServ Academy" },
			info: null,
			image: "",
			categories: [],
			engines: [1, 2, 3],
			description: "",
			links: [],
			children: [
				{
					id: 131,
					type: "service",
					title: { en: "Training Course PSA", de: "Training Course PSA" },
					info: null,
					image:
						"/apps/configurators/pielstick-engines-pa-pc/assets/images/primeServ-academies-480x270px.jpg",
					categories: [1, 2, 3],
					engines: [1, 2, 3],
					description:
						"Saint-Nazaire academy is the product academy for all S.E.M.T. Pielstick engines. It offers theoretical, hands-on, on-site, and remote live training on all S.E.M.T. Pielstick engines, turbochargers, and automation systems.<br><br>In France there is our certified training organization, for this reason, you are eligible for incurring training costs by your french OPCO.",
					links: [
						{
							text: { en: "Contact our experts", de: "Contact our experts" },
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "See training course catalog",
								de: "See training course catalog",
							},
							url: "https://www.everllence.com/campaigns/download/2026-saint-nazaire-academy-courses-catalog",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about PrimeServ Academy Saint-Nazaire",
								de: "More about PrimeServ Academy Saint-Nazaire",
							},
							url: "https://www.man-es.com/services/man-primeserv-academy/locations/man-primeserv-academy-saint-nazaire",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
	],
	pluses: [
		{
			id: 1,
			x: 50,
			y: 45,
			text: "Fuel Injection System",
			typeItemId: 1,
			type: "solution",
			direction: "right",
			allTimeVisible: true,
		},
		{
			id: 2,
			x: 58,
			y: 50,
			text: "Liner",
			typeItemId: 2,
			type: "solution",
			direction: "right",
			allTimeVisible: true,
		},
		{
			id: 3,
			x: 30,
			y: 45,
			text: "Automation & condition monitoring",
			typeItemId: 3,
			type: "solution",
			direction: "right",
			allTimeVisible: true,
		},
		{
			id: 4,
			x: 10,
			y: 61,
			text: "Alternative fuels",
			typeItemId: 4,
			type: "solution",
			direction: "right",
			allTimeVisible: true,
		},
		{
			id: 6,
			x: 80,
			y: 25,
			text: "Turbocharger",
			typeItemId: 5,
			type: "solution",
			direction: "right",
			allTimeVisible: true,
		},
		{
			id: 15,
			x: 60,
			y: 20,
			text: "Original spare parts",
			typeItemId: 6,
			type: "service",
			direction: "right",
			allTimeVisible: true,
		},
		{
			id: 8,
			x: 20,
			y: 69,
			text: "Technical services",
			typeItemId: 7,
			type: "service",
			direction: "right",
			allTimeVisible: true,
		},
		{
			id: 9,
			x: 31,
			y: 71,
			text: "Maintenance",
			typeItemId: 8,
			type: "service",
			direction: "right",
			allTimeVisible: true,
		},
		{
			id: 10,
			x: 65,
			y: 64,
			text: "Nuclear services",
			typeItemId: 9,
			type: "service",
			direction: "right",
			allTimeVisible: true,
		},
		{
			id: 11,
			x: 43,
			y: 71,
			text: "Service agreements",
			typeItemId: 10,
			type: "service",
			direction: "right",
			allTimeVisible: true,
		},
		{
			id: 12,
			x: 55,
			y: 69,
			text: "Consultancy",
			typeItemId: 11,
			type: "service",
			direction: "right",
			allTimeVisible: true,
		},
		{
			id: 13,
			x: 88,
			y: 44,
			text: "PrimeServ Academy",
			typeItemId: 14,
			type: "service",
			direction: "left",
			allTimeVisible: true,
		},
		{
			id: 14,
			x: 82,
			y: 52,
			text: "PrimeServ Lab",
			typeItemId: 13,
			type: "service",
			direction: "right",
			allTimeVisible: true,
		},

		{
			id: 16,
			x: 74,
			y: 58,
			text: "Turbocharger",
			typeItemId: 12,
			type: "service",
			direction: "right",
			allTimeVisible: true,
		},
	],
	categories: [
		{
			id: 1,
			type: "category",
			text: {
				en: "Efficiency",
				de: "Efficiency",
				singular: {
					en: "Efficiency",
					de: "Efficiency",
				},
			},
		},
		{
			id: 2,
			type: "category",
			text: {
				en: "Availability",
				de: "Availability",
				singular: {
					en: "Availability",
					de: "Availability",
				},
			},
		},
		{
			id: 3,
			type: "category",
			text: {
				en: "Reliability",
				de: "Reliability",
				singular: {
					en: "Reliability",
					de: "Reliability",
				},
			},
		},
		{
			id: 4,
			type: "category",
			text: {
				en: "Cost Reduction",
				de: "Cost Reduction",
				singular: {
					en: "Cost Reduction",
					de: "Cost Reduction",
				},
			},
		},
		{
			id: 5,
			type: "category",
			text: {
				en: "Emission Reduction",
				de: "Emission Reduction",
				singular: {
					en: "Emission Reduction",
					de: "Emission Reduction",
				},
			},
		},
		{
			id: 6,
			type: "category",
			text: {
				en: "Safety",
				de: "Safety",
				singular: {
					en: "Safety",
					de: "Safety",
				},
			},
		},
	],
	engines: [
		{
			id: 1,
			type: null,
			image:
				"/apps/configurators/pielstick-engines-pa-pc/assets/images/Pielstick-PA6.png",
			text: {
				en: "PA6",
				de: "PA6",
			},
		},
		{
			id: 2,
			type: null,
			image:
				"/apps/configurators/pielstick-engines-pa-pc/assets/images/Pielstick-PC2-5.png",
			text: {
				en: "PC2-5",
				de: "PC2-5",
			},
		},
		{
			id: 3,
			type: null,
			image:
				"/apps/configurators/pielstick-engines-pa-pc/assets/images/Pielstick-PC2-6.png",
			text: {
				en: "PC2-6",
				de: "PC2-6",
			},
		},
	],
	cart: {
		title: {
			de: "bookmarked solutions",
			en: "bookmarked solutions",
		},
	},
	navigation: [
		{
			key: "solution",
			title: {
				en: "Solutions",
				de: "Solutions",
			},
			panelItems: [1, 2, 3, 4, 5],
		},
		{
			key: "service",
			title: {
				en: "Services",
				de: "Services",
			},
			panelItems: [6, 7, 8, 9, 10, 11, 12, 13, 14],
		},
	],
};
